module.exports = __webpack_public_path__ + "img/scene-a.1dee4129.png";